export const EMAIL = "opheliamaeprocter@gmail.com";
export const WHATSAPP_URL =
  "https://wa.me/41796729890?text=" +
  encodeURIComponent(
    "Hi Ophelia, I found your website and I'd love to ask about private yoga sessions in Bath."
  );
